'use client'
import { usePathname } from 'next/navigation'
import React, { FC } from 'react'
import { useChat } from 'react-live-chat-loader'

import Button from '../common/Button/Button'
import NavButton from '../common/NavButton/NavButton'

type Props = {
  buttonText: string
  href: string
}

const GetInTouchButtons: FC<Props> = ({ buttonText, href }) => {
  const pathname = usePathname()
  const [_, loadChat] = useChat()
  const isPartnershipPage = pathname?.includes('/partnership')

  return isPartnershipPage ? (
    <NavButton id="primary-apply-network" href={href}>
      {buttonText}
    </NavButton>
  ) : (
    <Button id="primary-contact-bottom_banner" onClick={() => loadChat({ open: true })}>
      {buttonText}
    </Button>
  )
}

export default GetInTouchButtons
